import Add from './add';
import Edit from './edit';
import BuyNow from './buy-now';
import planPropsMixin from '@/plans/mx/plan-props';

export default function (planType) {
  return {
    mixins: [planPropsMixin],
    provide() {
      return {
        curPlanType: planType
      }
    },
    render() {
      const context = {
        ...this.$props,
        ...this.$attrs,
      };

      if (this.$context.is.add2cart) return <Add {...context} />;
      if (this.$context.is.edit) return <Edit {...context} />;
      return <BuyNow {...context} />;
    },
  };
}
